import React from "react";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CREATE_ORDER_USER_ID = "A1437";

const CreateBulkOrder = ({ userID, receiptDetails }) => {
  const navigate = useNavigate();

  if (String(userID || "") !== CREATE_ORDER_USER_ID) {
    return null;
  }

  const handleCreateOrderClick = () => {
    if (String(userID || "") !== CREATE_ORDER_USER_ID) {
      toast.error("Create Order is not available for this user");
      return;
    }

    navigate("/orders/create-bulk-order", {
      state: {
        receiptDetails: receiptDetails || {},
      },
    });
  };

  return (
    <button
      type="button"
      onClick={handleCreateOrderClick}
      className="flex items-center gap-2 bg-emerald-600 text-white px-4 py-2 rounded text-sm font-medium hover:bg-emerald-700 transition"
    >
      <Plus size={16} />
      Create Order
    </button>
  );
};

export default CreateBulkOrder;
